"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _component = _interopRequireDefault(require("@loadable/component"));

var _clsx = _interopRequireDefault(require("clsx"));

var _DetectLink = _interopRequireDefault(require("./DetectLink.styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Grid = (0, _component.default)(function () {
  return import("@material-ui/core/Grid");
});
var ReactLink = (0, _component.default)(function () {
  return import("@micado-digital/react-link/ReactLink");
});
var ReactSVGIcon = (0, _component.default)(function () {
  return import("@micado-digital/react-svg-icon/ReactSVGIcon");
});
var Typography = (0, _component.default)(function () {
  return import("@micado-digital/react-ui/components/Typography");
});

var DetectLink = function DetectLink(_ref) {
  var addition = _ref.addition,
      endIcon = _ref.endIcon,
      icon = _ref.icon,
      iconSize = _ref.iconSize,
      linkVariant = _ref.linkVariant,
      linkVariants = _ref.linkVariants,
      media = _ref.media,
      reference = _ref.reference,
      startIcon = _ref.startIcon,
      text = _ref.text,
      title = _ref.title;
  var css = (0, _DetectLink.default)();
  var url = (0, _react.useMemo)(function () {
    var _media$find;

    var mediaLink = media === null || media === void 0 ? void 0 : (_media$find = media.find(function (item) {
      return (item === null || item === void 0 ? void 0 : item.mediaType) === "link";
    })) === null || _media$find === void 0 ? void 0 : _media$find.filename;

    if (mediaLink) {
      return mediaLink;
    } else if (reference !== null && reference !== void 0 && reference.pageName) {
      return reference === null || reference === void 0 ? void 0 : reference.pageName;
    } else {
      return text;
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);

  if (addition === "_blank") {
    return /*#__PURE__*/_react.default.createElement(Grid, {
      className: (0, _clsx.default)("mco-references-01__list-item", css.item),
      item: true,
      xs: 12
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: url,
      target: "_blank",
      rel: "noreferrer"
    }, icon && /*#__PURE__*/_react.default.createElement(ReactSVGIcon, {
      className: css.icon,
      color: "secondary",
      src: "/img/icons/arrow-right.svg",
      width: iconSize
    }), startIcon && startIcon, /*#__PURE__*/_react.default.createElement(Typography, {
      className: (0, _clsx.default)("mco-references-01__list-label", css.label),
      dangerouslySetInnerHTML: {
        __html: title
      },
      variant: linkVariant,
      variants: linkVariants
    }), endIcon && endIcon));
  } else if (addition === "mailto") {
    return /*#__PURE__*/_react.default.createElement(Grid, {
      className: (0, _clsx.default)("mco-references-01__list-item", css.item),
      item: true,
      xs: 12
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: "mailto:".concat(url)
    }, icon && /*#__PURE__*/_react.default.createElement(ReactSVGIcon, {
      className: css.icon,
      color: "secondary",
      src: "/img/icons/arrow-right.svg",
      width: iconSize
    }), startIcon && startIcon, /*#__PURE__*/_react.default.createElement(Typography, {
      className: (0, _clsx.default)("mco-references-01__list-label", css.label),
      dangerouslySetInnerHTML: {
        __html: title
      },
      variant: linkVariant,
      variants: linkVariants
    }), endIcon && endIcon));
  } else {
    return /*#__PURE__*/_react.default.createElement(Grid, {
      className: (0, _clsx.default)("mco-references-01__list-item", css.item),
      item: true,
      xs: 12
    }, /*#__PURE__*/_react.default.createElement(ReactLink, {
      to: url
    }, icon && /*#__PURE__*/_react.default.createElement(ReactSVGIcon, {
      className: css.icon,
      color: "secondary",
      src: "/img/icons/arrow-right.svg",
      width: iconSize
    }), startIcon && startIcon, /*#__PURE__*/_react.default.createElement(Typography, {
      className: (0, _clsx.default)("mco-references-01__list-label", css.label),
      dangerouslySetInnerHTML: {
        __html: title
      },
      variant: linkVariant,
      variants: linkVariants
    }), endIcon && endIcon));
  }
};

var _default = DetectLink;
exports.default = _default;